module.exports = __webpack_public_path__ + "static/media/ben-headshot3.fb3b1e78.jpg";